// @ngInject

Models.CompaniesCollection = function CompaniesCollection(BaseCollection) {

    return Class(BaseCollection, {

            constructor: function constructor() {
                this.constructor.$super.call(this);
                this._collection.__className = 'CompaniesCollection';
                this._collection.__childsType = 'CompanyModel';
                return this._collection;
            }
        }
    );

};
